export var StepConnectorOverrides = function (theme) {
    var _a;
    return ({
        MuiStepConnector: {
            vertical: {
                marginLeft: '7px',
                padding: '0 0 5px 0',
            },
            lineVertical: (_a = {
                    borderLeftWidth: '2px',
                    borderColor: theme.palette.secondary.main,
                    minHeight: '16px',
                    display: 'none'
                },
                _a[theme.breakpoints.up('sm')] = {
                    display: 'block',
                },
                _a),
            active: {
                '& $lineVertical': {
                    borderColor: theme.palette.brand.main,
                },
            },
            completed: {
                '& $lineVertical': {
                    borderColor: theme.palette.brand.main,
                },
            },
        },
    });
};
//# sourceMappingURL=StepConnector.overrides.js.map